import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { abyssColors } from '@/theme/colors';
import { FormHeader, LineBreak } from '../TemplateForm/styles';

const AGGREGATION_OPTIONS = [
  { value: 'workpack', label: 'Workpack' },
  { value: 'structure', label: 'Structure' },
] as const;

type TemplateSettings = {
  name?: string | null;
  key?: string | null;
  supportsMultipleEntries?: boolean | null;
  supportsShifts?: boolean | null;
  aggregationLevel?: string | null;
};

type QaqcTemplateSettingsPanelProps = {
  structureId: string;
  template: TemplateSettings | null | undefined;
};

export const QaqcTemplateSettingsPanel = ({
  structureId: _structureId,
  template,
}: QaqcTemplateSettingsPanelProps) => {
  if (!template) {
    return null;
  }

  const supportsMultipleEntries = template.supportsMultipleEntries ?? false;
  const supportsShifts = template.supportsShifts ?? false;
  const aggregationLevel = template.aggregationLevel ?? 'workpack';

  return (
    <Box sx={{ pt: 3 }}>
      <FormHeader>
        <Typography fontSize="2rem" fontWeight={600} color={abyssColors.primary[600]}>
          Template settings
        </Typography>
      </FormHeader>

      <LineBreak marginBottom={2} />

      <Stack spacing={3} sx={{ maxWidth: '40rem' }}>
        <TextField
          label="Display name"
          value={template.name ?? ''}
          disabled
          fullWidth
          slotProps={{ input: { readOnly: true } }}
          helperText="Template display name (read-only)"
        />
        <TextField
          label="Key"
          value={template.key ?? ''}
          disabled
          fullWidth
          slotProps={{ input: { readOnly: true } }}
          helperText="Template key (read-only)"
        />

        <Box>
          <Typography variant="subtitle2" color="text.secondary">
            Supports multiple entries
          </Typography>
          <Typography variant="body1">{supportsMultipleEntries ? 'Yes' : 'No'}</Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2" color="text.secondary">
            Supports shifts
          </Typography>
          <Typography variant="body1">{supportsShifts ? 'Yes' : 'No'}</Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2" color="text.secondary">
            Aggregation level
          </Typography>
          <Typography variant="body1">
            {AGGREGATION_OPTIONS.find((option) => option.value === aggregationLevel)?.label ??
              aggregationLevel ??
              'Workpack'}
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
};
